export const getCountries = (data) => {
    const result = {
        page_size: data.page_size || 1000,
    };
    if (data.language) {
        result.lang = data.language;
    }
    return result;
};
